<template>
  <div class="personal-page">
    <img src="/images/yanfei.jpg" alt="Yanfei Liu Photo" class="staff-photo" />
    <div class="personal-details">
      <h2>Yanfei Liu</h2>
      <p>A researcher on Artificial Intelligence with educational background in Engineering Mechanics, Chemical Engineering Machinery, Vibration & Acoustics, and Computer Science & Technology.</P><P>A Professor of Computer Science & Technology, work experience involves Government Department, Founder of an IT company, and Teaching and Researches in university.</P><P>Research interestings include Cognitive Architecture, Cognitive Modeling & Simulation, Human Factors, Human-computer Interaction and Software Engineering.</p>
      <p><strong>Contact Information:</strong></p>
      <ul>
        <li>Address: 7053 Montecito Ln, Eastvale, CA 92880</li>
        <li>Email: zstulyf@gmail.com</li>
        <li>Website: <a href="https://www.ifusion.cc/yanfei" target="_blank">https://www.ifusion.cc/yanfei</a></li>
      </ul>
      <p><strong>Educational Background:</strong></p>
      <ul>
        <li>PhD, Computer Science & Technology, <a href="https://www.zju.edu.cn" target="_blank">Zhejiang University</a>, 2007</li>
        <li>MS, Vibration, Shock, and Acoustic, <a href="https://www.zju.edu.cn" target="_blank">Zhejiang University</a>, 1994</li>
        <li>B.Eng., Engineering Mechanics (Chemical Engineering Machinery), <a href="https://www.zzu.edu.cn" target="_blank">Zhengzhou University</a>, 1991</li>
      </ul>
      <p><strong>Work Experience:</strong></p>
      <ul>
        <li>Professor, <a href="https://www.zstu.edu.cn" target="_blank">Zhejiang Sci-Tech University</a>, 2007–2023</li>
        <li>Founder & CEO, <a href="https://cnfusion.cc" target="_blank">Hangzhou Fusion Information System Integration Co., Ltd.</a>, 2000–2023</li>
        <li>Director of Software Development, Office Information Processing Centre, <a href="https://hangzhou.gov.cn" target="_blank">Hangzhou Municipal People's Government</a>1, 994–2000</li>
      </ul>
      <p><strong>Recently Paper in Conference Proceedings:</strong></p>
      <ul>
        <li><b>Yanfei Liu</b>, Chao Shen, Junsong Liu, Feng Fu, and Yuzhou Liu. Situation awareness monitoring by behaviour detection and model’s processes retroaction for crew member of nuclear power plant. In Cognitive Computing and Internet of Things, volume 73, pages 162–168. AHFE International, 2023</li>
        <li><b>Yanfei Liu</b>, Chao Shen, and Yuzhou Liu. Combining minds and machines: Investigating the fusion of cognitive architectures and generative models for general embodied intelligence. In Proceedings of the 2023 AAAI Fall Symposium. AAAI Press, 2023.</li>
        <li><b>Yanfei Liu</b>, Xin Wang, Zhiqiang Tian, Liang Zhang, Yuzhou Liu, Junsong Li, and Feng Fu. Towards a most suitable way for AGI from cognitive architecture, modeling and simulation. In International Conference on Applied Human Factors and Ergonomics, pages 165–173. Springer, 2021.</li>
      </ul>
      <p><strong>Key Project Sponsors:</strong></p>
      <ul>
        <li>Research on Cognitive and Behavioral Performance Modeling Technology of Nuclear Power Crew, funded by the <a href="http://www.cgnp.com.cn/" target="_blank">CGN Research Institute CO., LTD</a>. 2022-2024</li>
        <li>Research on Modeling Method of Crew Members Cognitive Behavior and Decisionmaking, funded by the <a href="http://cimtec.cssc.net.cn/" target="_blank">China Institute of Marine Technology and Economic</a>. 2019-2023</li>
        <li>Research on Cognitive Behavior Modeling and Performance Evaluation of Astronauts in Spacecraft Rendezvous and Docking Mission Based on ACT-R, funded by the <a href="https://zjnsf.kjt.zj.gov.cn/portal/index.html" target="_blank">Natural Science Foundation of Zhejiang Province</a>. 2012-2013</li>
        <li>Implementation of Cognitive Modeling and Simulation for Rendezvous and Docking Tasks, funded by the China Astronaut Research and Training Center. 2012-2016</li>
      </ul>
      <p><strong>Additional Information:</strong></p>
      <ul>
        <li>Languages: Mandarin (native), English (fluent)</li>
        <li>Hobbies: Chinese handwriting, hiking, table tennis</li>
      </ul>
    </div>
  </div>
</template>

<style>
.personal-page p,
.personal-page .personal-details ul li{
    font-size: 14px; /* Smaller font size for <p> elements */
    text-indent: 2em; /* Indent the first line by 2em */
    font-family: 'Georgia', serif; /* Change the font to Georgia */
}
.personal-page p::first-line {
    
    /*font-size: 16px;  Slightly larger font for the first line */
    color: #555; /* Optional: Set a custom color */
}
</style>